import Helper from '@ember/component/helper';
// import config from 'back-office/config/environment';

class ObjectUrl extends Helper {
  compute([fileObject, path, config]) {
    if (!fileObject) {
      return '';
    } else if (fileObject.file) {
      return URL.createObjectURL(fileObject.file);
    } else if (fileObject instanceof Object) {
      return `${config.static}${path ? `${path}/` : ''}${fileObject.filename}`;
    }
    return '';
  }
}
export default ObjectUrl;